import createIcon from '../../createIcon';

/**
 * @component @name ContactPhone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgM0gyQzAuOSAzIDAgMy45IDAgNVYxOUMwIDIwLjEgMC45IDIxIDIgMjFIMjJDMjMuMSAyMSAyMy45OSAyMC4xIDIzLjk5IDE5TDI0IDVDMjQgMy45IDIzLjEgMyAyMiAzWk04IDZDOS42NiA2IDExIDcuMzQgMTEgOUMxMSAxMC42NiA5LjY2IDEyIDggMTJDNi4zNCAxMiA1IDEwLjY2IDUgOUM1IDcuMzQgNi4zNCA2IDggNlpNMTQgMThIMlYxN0MyIDE1IDYgMTMuOSA4IDEzLjlDMTAgMTMuOSAxNCAxNSAxNCAxN1YxOFpNMTcuODUgMTRIMTkuNDlMMjEgMTZMMTkuMDEgMTcuOTlDMTcuNyAxNy4wMSAxNi43MyAxNS42MSAxNi4yOCAxNEMxNi4xIDEzLjM2IDE2IDEyLjY5IDE2IDEyQzE2IDExLjMxIDE2LjEgMTAuNjQgMTYuMjggMTBDMTYuNzMgOC4zOCAxNy43IDYuOTkgMTkuMDEgNi4wMUwyMSA4TDE5LjQ5IDEwSDE3Ljg1QzE3LjYzIDEwLjYzIDE3LjUgMTEuMyAxNy41IDEyQzE3LjUgMTIuNyAxNy42MyAxMy4zNyAxNy44NSAxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ContactPhone = createIcon('ContactPhone', [
  [
    'path',
    {
      d: 'M22 3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H22C23.1 21 23.99 20.1 23.99 19L24 5C24 3.9 23.1 3 22 3ZM8 6C9.66 6 11 7.34 11 9C11 10.66 9.66 12 8 12C6.34 12 5 10.66 5 9C5 7.34 6.34 6 8 6ZM14 18H2V17C2 15 6 13.9 8 13.9C10 13.9 14 15 14 17V18ZM17.85 14H19.49L21 16L19.01 17.99C17.7 17.01 16.73 15.61 16.28 14C16.1 13.36 16 12.69 16 12C16 11.31 16.1 10.64 16.28 10C16.73 8.38 17.7 6.99 19.01 6.01L21 8L19.49 10H17.85C17.63 10.63 17.5 11.3 17.5 12C17.5 12.7 17.63 13.37 17.85 14Z',
      key: 'wl2twu',
    },
  ],
]);

export default ContactPhone;
